import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Select from 'react-select';

export default function StatusReport() {
    const [lists, setLists] = useState([]);
    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState([]);
    const [clientId, setClientId] = useState("00000000-0000-0000-0000-000000000000");
    const [totalRecords, setTotalRecords] = useState(0);

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }

    const GetData = (id = clientId) => {
        setLoading(true);
        axios
            .get(config.APIACTIVATEURL + config.STATUSREPORT + "?clientId=" + id, { ...headerconfig })
            .then(function (response) {
                if (response.status === 200) {
                    setLists(response.data.data);
                    setTotalRecords(response.data.data.length);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
    };

    const GetClients = () => {
        axios.get(config.APIACTIVATEURL + config.GETALLCLIENTS, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClients(response.data.data);
                }
            })
            .catch(error => {
                console.error("Error fetching clients:", error);
            });
    };

    const handleSearch = () => {
        GetData();
    };

    const resetForm = () => {
        const defaultId = "00000000-0000-0000-0000-000000000000";
        setClientId(defaultId);
        GetData(defaultId); // Pass the default ID directly to ensure it's used
    };

    useEffect(() => {
        GetData();
        GetClients();
        if (localStorage.getItem("roleName") === "CLIENT") {
            const id = localStorage.getItem("clientId");
            setClientId(id);
            GetData(id);
        }
    }, []);

    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="card card-body py-3">
                        <div className="row mb-3 mt-3">
                            <div className="col-sm-5">
                                <label className="form-label">Client</label>
                                <Select
                                    options={[
                                        { value: "00000000-0000-0000-0000-000000000000", label: "All Clients" },
                                        ...clients.map(c => ({ value: c.clientId, label: c.clientName }))
                                    ]}
                                    onChange={(selectedOption) => {
                                        setClientId(selectedOption.value);
                                    }}
                                    value={{
                                        value: clientId,
                                        label: clientId === "00000000-0000-0000-0000-000000000000"
                                            ? "All Clients"
                                            : clients.find(c => c.clientId === clientId)?.clientName || "Select Client"
                                    }}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            maxHeight: '300px',
                                            overflowY: 'auto',
                                        }),
                                    }}
                                    isSearchable={true}
                                    placeholder="Select Client"
                                />
                            </div>
                            <div className="col-sm-3">
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {loading === true ?
                                        <button type="button" className="btn btn-success" disabled>Loading..</button>
                                        :
                                        <button type="button" className="btn btn-success" onClick={handleSearch}>Search</button>}
                                    <button type="button" className="btn btn-danger" onClick={resetForm}>Clear</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card w-100 position-relative overflow-hidden">
                                <div className="px-4 py-3 border-bottom">
                                    <h4 className="card-title mb-0">Applications Status Report</h4>
                                </div>
                                <div className="card-body p-4">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Client Name</th>
                                                    <th>Pending</th>
                                                    <th>Submitted</th>
                                                    <th>Pending Approval</th>
                                                    <th>Approved</th>
                                                    <th>Awaiting Funding</th>
                                                    <th>Funded</th>
                                                    <th>Rejected</th>
                                                    <th>Total Applications</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {lists.length > 0 ? (
                                                    lists.map((v, index) => (
                                                        <tr key={v.clientId}>
                                                            <td>{index + 1}</td>
                                                            <td>{v.clientName}</td>
                                                            <td>{v.pendingCount}</td>
                                                            <td>{v.submittedCount}</td>
                                                            <td>{v.pendingApprovalCount}</td>
                                                            <td>{v.approvedCount}</td>
                                                            <td>{v.awaitingFundingCount}</td>
                                                            <td>{v.fundedCount}</td>
                                                            <td>{v.rejectedCount}</td>
                                                            <td>{v.totalApplications}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10" className="text-center">
                                                            {loading ? 'Loading data...' : 'No data available'}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    {lists.length > 0 && (
                                        <div className="text-muted mt-2">
                                            Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}